<script lang="ts">
    import { untrack } from 'svelte';
    import { api } from '../lib/api';
    import { toast } from '../lib/stores/toast.svelte';
    import type { SecretGroup } from '../lib/types';

    let { group, appScopeId, environmentId, onClose, onSaved }: {
        group: SecretGroup | null;
        appScopeId: string | null;
        environmentId: string;
        onClose: () => void;
        onSaved: () => void;
    } = $props();

    let name = $state(untrack(() => group?.name ?? ''));
    let saving = $state(false);
    let dialog = $state<HTMLDialogElement>();

    $effect(() => { if (dialog && !dialog.open) dialog.showModal(); });

    async function save() {
        saving = true;
        try {
            if (group) {
                await api(`/api/groups/${group.id}`, { method: 'PATCH', body: JSON.stringify({ name }) });
            } else {
                await api('/api/groups', { method: 'POST', body: JSON.stringify({ name, environmentId, appScopeId }) });
            }
            toast.success('Group saved');
            onSaved();
        } catch (err: any) {
            toast.error(err.message);
        } finally {
            saving = false;
        }
    }
</script>

<dialog bind:this={dialog} onclose={onClose}>
    <header><h2>{group ? 'Rename Group' : 'New Group'}</h2></header>
    <div class="body">
        <label>
            Name
            <input bind:value={name} placeholder="S3 Credentials" />
        </label>
    </div>
    <footer>
        <button onclick={() => { dialog?.close(); onClose(); }}>Cancel</button>
        <button class="primary" onclick={save} disabled={saving || !name}>Save</button>
    </footer>
</dialog>

<style>
    header { padding: 16px 20px; border-bottom: 1px solid var(--border); }
    header h2 { margin: 0; font-size: 16px; }
    .body { padding: 16px 20px; }
    label { display: flex; flex-direction: column; gap: 6px; font-size: 13px; }
    footer { padding: 12px 20px; border-top: 1px solid var(--border); display: flex; justify-content: flex-end; gap: 8px; }
</style>